import {
  BrowserCacheLocation,
  type Configuration,
  ProtocolMode,
} from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID || '',
    authority: import.meta.env.VITE_AUTHORITY || '',
    knownAuthorities: ['https://cwslogin.b2clogin.com'],
    protocolMode: ProtocolMode.OIDC, // Configure AAD or OIDC
    redirectUri: import.meta.env.VITE_REDIRECT_URI || '',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
}
